import { IconButton, TableCell, TableRow, Typography } from "@mui/material"
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { AppColors } from "resources/AppColors";

const ProfessionalToDisplay = ({ professional, handleShowEditModal, handleShowDeleteModal }) => (
  <TableRow
    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
  >
    <TableCell align="left">
      <Typography variant='body'>{professional.fullName}</Typography>
    </TableCell>
    <TableCell align="left">
      <Typography variant='body'>{professional.user?.email}</Typography>
    </TableCell>
    <TableCell align="left">
      <Typography variant='body'>{professional.organization || '-'}</Typography>
    </TableCell>
    <TableCell align="left">
      <Typography variant='body'>{professional.profile || '-'}</Typography>
    </TableCell>
    <TableCell align="center" p={0}>
      {handleShowEditModal &&
        <IconButton onClick={() => handleShowEditModal(professional)} size="large">
          <EditIcon sx={{ fill: AppColors.PRIMARY }} />
        </IconButton>}
      {handleShowDeleteModal &&
        <IconButton onClick={() => handleShowDeleteModal(professional)} size="large">
          <DeleteIcon sx={{ fill: AppColors.PRIMARY }} />
        </IconButton>}
    </TableCell>
  </TableRow>
)

export default ProfessionalToDisplay